import { useIntl } from "react-intl";
import { useState } from "react";
import { Modal } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useDispatch } from 'react-redux';
import { BudgetDTO } from "../../dto/budget/BudgetDTO";
import { duplicateBudget } from "../../servicesHooks/Budget/useBudgetService";

interface DuplicateBudgetModalProps {
  openDuplicateBudgetModal: boolean;
  setOpenDuplicateBudgetModal: (open: boolean) => void;
  budgetId: number;
  onDuplicateBudget:(value:BudgetDTO)=>void;
}

export default function DuplicateBudgetModal({openDuplicateBudgetModal, setOpenDuplicateBudgetModal, onDuplicateBudget, budgetId}: DuplicateBudgetModalProps) {

  const dispatch = useDispatch();
  const intl = useIntl();
  const [isMobile] = useState(window.innerWidth <= 768);

  function duplicate(withUpdatePrices:boolean) {
      duplicateBudget(budgetId,withUpdatePrices).then((res:BudgetDTO) => {
        setOpenDuplicateBudgetModal(false);
        onDuplicateBudget(res);
      });
  }

  return (
    <Modal
      visible={openDuplicateBudgetModal}
      setVisible={setOpenDuplicateBudgetModal}
      className="nv-scope nv-dialog custom-modal w-auto"
      header={<span className="nv-modal-title">{`Estás por duplicar este presupuesto...`}</span>}
      footerButtonRightText = {"Actualizar precios"}
      footerButtonLeftText= {"Sin actualizar precios"}
      onClickLeftBtn = {()=>duplicate(false)}
      onClickRightBtn={()=>duplicate(true)}
      closable={false}
    >
      <div style={{ minWidth: isMobile ? "" : "150px" }}>
        <div className="flex flex-column gap-2">
          <span>Podemos mantener los valores anteriores o actualizarlos al día de hoy. ¿Cómo preferís que se vean los precios al duplicar?</span>
        </div>
      </div>
    </Modal>
  );
}